import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';

export class PayoutCommissionReport extends AbstractReport {

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {

        return [ 'name' ];
    }
}
AccessorsMutatorsDecorator(
    'id',
    ...PayoutCommissionReport.translatableAttributesWithLanguageAliases,
    'reservations',
    'room_total',
    'deleted_at',
)(PayoutCommissionReport);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/financial/payout-commission-report.model.js